import type { CourseDetail } from "@/lib/types/course/detail"
import type { BlogDetail } from "@/lib/types/blog/detail"
import type { ReactNode } from "react"

export interface IGridItemProps {
	data?: CourseDetail | BlogDetail
	type?: "blog" | "course"
	showMore?: boolean
	tags?: boolean
	priority?: boolean
	showDetail?: boolean
}

export interface IBadgeProps {
	icon: ReactNode
	text: string
	variant?: keyof typeof BADGE_STYLES
}

export interface ICourseGridCardProps {
	data: CourseDetail
	contentPrice: string
	discountContentCard: ReactNode
	priority?: boolean
	showDetail?: boolean
}

// Constants
export const LEARNING_MODES = {
	VIDEO_ONLINE: "Video Online",
	GOOGLE_MEET: "Trực tuyến - Google Meet",
} as const

export const BADGE_STYLES = {
	default: {
		bg: "bg-gray-100",
		text: "text-gray-800",
	},
	green: {
		bg: "bg-green-100",
		text: "text-green-800",
	},
	blue: {
		bg: "bg-blue-100",
		text: "text-blue-800",
	},
	red: {
		bg: "bg-red-100",
		text: "text-red-800",
	},
	purple: {
		bg: "bg-purple-100",
		text: "text-purple-800",
	},
} as const 